import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import AppUser from 'js/stores/AppUser';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { isPhoneNumber, names } from 'js/services/Regex';

import TokenPageState from 'js/stores/pages/TokenPageState';

import Token from './Token';
import SizeDetails from './SizeDetails';
import PickupDetails from './PickupDetails';
import ReceivingAccount from './ReceivingAccount';
import SignUpSignIn from './SignUpSignIn';
import BuyerInfo from './BuyerInfo';

@observer
export default class TokenPage extends SteppedComponent {
  pageName = 'TokenPage';
  pageColor = lightGrey1Color;

  bootstrap = () => this.page.load();

  page = TokenPageState.create({
    alias: this.props.alias,
  }).setSteps(this, 'token-page', [
    {
      name: 'token',
      label: 'Token',
      component: Token,
      onEnter: (page, step) => { /*analytics.page('SAC_viewed coupon offer page')*/ },
    },
    {
      name: 'size',
      label: 'Size',
      component: SizeDetails,
      isComplete: (page, step) => !!page.size,
      onEnter: (page, step) => { /*analytics.page('SAC_viewed item size page')*/ },
      showStepMenu: true,
    },
    {
      name: 'pickup-details',
      label: 'Pick-up details',
      component: PickupDetails,
      isComplete: (page, step) => page.address.hasAddress,
      onEnter: (page, step) => { /*analytics.page('SAC_viewed pickup address page')*/ },
      showStepMenu: true,
    },
    {
      name: 'receiving-account',
      label: 'Receiving account',
      component: ReceivingAccount,
      isComplete: (page, step) => page.bankAccount.isFilledIn || !!page.debitCard.number,
      onEnter: (page, step) => { /*analytics.page('SAC_viewed receiving account page')*/ },
      showStepMenu: true,
    },
    {
      name: 'signup',
      label: 'Sign up',
      component: SignUpSignIn,
      onEnter: (page, step) => { /*analytics.page('SAC_viewed sign up page')*/ },
      onLeave: (page, step) => {
        if (!page.full_name) {
          page.setFullName(AppUser.name || '');
        }
        if (!page.phone_number) {
          page.setPhoneNumber(AppUser.phone_number || '');
        }
      },
      skipWhen: (page, step) => AppUser.isLoggedIn,
    },
    {
      name: 'info',
      label: 'Info',
      component: BuyerInfo,
      isComplete: (page, step) =>
        !!(
          page.phone_number.match(isPhoneNumber) &&
          page.full_name &&
          page.full_name.match(names) &&
          page.full_name.match(names).length >= 2
        ),
      onEnter: (page, step) => { /*analytics.page('SAC_viewed user info')*/ },
      skipWhen: (page, step) => step.isComplete(page, step),
    },
  ]);
}
